import React, { useState, useEffect } from 'react';

const AdvertisingBanner = () => {
  const [currentAd, setCurrentAd] = useState(0);
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  // Charger les publicités depuis le backend
  useEffect(() => {
    const fetchAds = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/advertisements/active`);
        const data = await response.json();
        
        if (data.ads && data.ads.length > 0) {
          setAds(data.ads);
        } else {
          // Publicités par défaut si aucune n'est uploadée
          setAds([
            {
              id: 1,
              title: "🎬 Vends tes clips et gagne de l'argent !",
              description: "Upload tes clips sur AGRP BOX MusicBox et commence à vendre dès maintenant",
              color: "from-green-600 to-green-800",
              cta: "Commencer",
              link: "/mon-espace-artiste",
              image: null
            },
            {
              id: 2,
              title: "🚀 Passe ton clip en LIVE avec +3000 vues !",
              description: "Diffuse ton clip en direct avec AGRP BOX - 50$ seulement",
              color: "from-cyan-600 to-cyan-800",
              cta: "Réserver",
              link: "/service/live-streaming",
              image: null
            },
            {
              id: 3,
              title: "📈 Promouvoir ta vidéo - À partir de 15$",
              description: "1000 vues garanties pour seulement 15$ avec publicité Ads",
              color: "from-yellow-600 to-yellow-800",
              cta: "Promouvoir",
              link: "/service/boost",
              image: null
            },
            {
              id: 4,
              title: "🎵 Distribue ta musique sur Spotify & Apple Music",
              description: "Mets ta musique sur toutes les plateformes - 15$ seulement",
              color: "from-purple-600 to-purple-800",
              cta: "Distribuer",
              link: "/service/distribution",
              image: null
            }
          ]);
        }
      } catch (error) {
        console.error('Erreur chargement publicités:', error);
        // Garder les pubs par défaut en cas d'erreur
        setAds([
          {
            id: 1,
            title: "🎬 Vends tes clips et gagne de l'argent !",
            description: "Upload tes clips sur AGRP BOX et commence à vendre dès maintenant",
            color: "from-green-600 to-green-800",
            cta: "Commencer",
            link: "/mon-espace-artiste",
            image: null
          },
          {
            id: 2,
            title: "🚀 Passe ton clip en LIVE avec +3000 vues !",
            description: "Diffuse ton clip en direct avec AGRP BOX - 50$ seulement",
            color: "from-cyan-600 to-cyan-800",
            cta: "Réserver",
            link: "/service/live-streaming",
            image: null
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchAds();
  }, []);

  useEffect(() => {
    if (ads.length === 0) return;
    
    const interval = setInterval(() => {
      setCurrentAd((prev) => (prev + 1) % ads.length);
    }, 4000); // Change toutes les 4 secondes

    return () => clearInterval(interval);
  }, [ads.length]);

  if (loading || ads.length === 0) return null;

  const ad = ads[currentAd];

  return (
    <div className="relative overflow-hidden mb-8">
      <div className={`${ad.image ? 'bg-cover bg-center' : `bg-gradient-to-r ${ad.color}`} rounded-lg shadow-lg transform transition-all duration-500 relative`}
           style={ad.image ? { backgroundImage: `url(${process.env.REACT_APP_BACKEND_URL}/api/storage/files/${ad.image})` } : {}}>
        
        {/* Overlay sombre si image de fond */}
        {ad.image && <div className="absolute inset-0 bg-black/50 rounded-lg"></div>}
        
        <div className="relative p-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1 text-white z-10">
            <h3 className="text-xl font-bold mb-2">{ad.title}</h3>
            <p className="text-white/90 text-sm">{ad.description}</p>
          </div>
          
          <a
            href={ad.link}
            className="bg-white text-gray-900 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap z-10"
          >
            {ad.cta}
          </a>
        </div>
        
        {/* Indicateurs de pagination */}
        {ads.length > 1 && (
          <div className="relative flex justify-center gap-2 pb-4">
            {ads.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentAd(index)}
                className={`h-2 rounded-full transition-all ${
                  index === currentAd 
                    ? 'w-8 bg-white' 
                    : 'w-2 bg-white/40 hover:bg-white/60'
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvertisingBanner;
